import { render } from "./ConsumptionItem.vue?vue&type=template&id=2cb60c22"
import script from "./ConsumptionItem.vue?vue&type=script&lang=js"
export * from "./ConsumptionItem.vue?vue&type=script&lang=js"
script.render = render

export default script